module.exports = __webpack_public_path__ + "static/scl-health-57a3a921663df91bf6049e2d0754df42.png";